<template>
  <div class="parameters-list">
    <div class="parameters-list__heading">
      <div class="container">
        <h1>Paramètres</h1>
      </div>
    </div>
    <PParametersList :sections="sections" :toggles="toggles" />
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue'
import { PParametersList } from '@invivodf/common/src/contexts/parameters'
import { useParameters } from '../../application/composables/useParameters'
import { useParameterToggles } from '../../application/composables/useParameterToggles'
import { useAuthentication } from '../../../user/application/composables/useAuthentication'

export default defineComponent({
  name: 'VParametersList',
  components: { PParametersList },
  setup() {
    const roles = ref([])

    const { getRoles } = useAuthentication()
    const { sections } = useParameters()
    const { toggles, init } = useParameterToggles(roles)

    onMounted(async () => {
      roles.value = await getRoles()
      await init()
    })

    return {
      sections,
      toggles,
    }
  },
})
</script>

<style scoped lang="scss">
.parameters-list {
  display: flex;
  flex-direction: column;
}
.parameters-list__heading {
  padding: 3em 0;
  h1 {
    font-weight: bold;
    font-size: 1.8em;
  }
}
</style>
